import { UploadIcon } from '@primer/octicons-react';
import { Box, Text } from '@primer/react';
import { useState } from 'react';
import { uploadApi } from '../../api/uploadApi';
import { IUploadRespone } from '../../models/response/upload/IUploadRespone';
import Files from '../files/Files';
import Button from '../ui/button';
interface IFileViewAndUploadProps {
    files: IUploadRespone[];
    onValueChanged: (files: IUploadRespone[]) => void;
    accept?: string;
    showEmptyMessage?: boolean;
}
const FileViewAndUpload = (props: IFileViewAndUploadProps) => {
    const [isUploading, setIsUploading] = useState(false);

    const handleSelectFile = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('multiple', 'true');
        input.setAttribute('accept', props.accept ?? 'image/png, image/gif, image/jpeg');
        input.click();
        input.onchange = async () => {
            if (input.files) {
                setIsUploading(true)
                const res = await uploadApi.uploadImages(input.files)
                setIsUploading(false)
                if (res.is_success) {
                    console.log({
                        files: res.data
                    });
                    props.onValueChanged([...props.files, ...res.data.map((x: any) => {
                        return {
                            id: 0,
                            url: x.url,
                            file_extension: x.file_name.split(".").pop(),
                            sort_idx: "",
                            file_name: x.file_name,

                        } as IUploadRespone
                    })]);

                }
            }


        };
    };
    return (
        <Box>
            {props.files.length === 0 && (
                <Button
                    variant='default'
                    text='Đính kèm file'
                    size='small'
                    isLoading={isUploading}
                    leadingVisual={UploadIcon}
                    onClick={handleSelectFile}
                />
            )}

            {props.files.length > 0 && (
                <Box>
                    <Files
                        files={props.files}
                        onFileRemove={(url) => {
                            props.onValueChanged(props.files.filter((x) => x.url !== url));
                        }}
                        showEmptyMessage={props.showEmptyMessage}
                    />
                    <Box sx={{ mt: 2 }}>
                        <Button
                            variant='primary'
                            text='Thêm file khác'
                            size='small'
                            isLoading={isUploading}
                            leadingVisual={UploadIcon}
                            onClick={handleSelectFile}
                        />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default FileViewAndUpload;